enum GtmFormulareingabeField {
    SB = 'SB',
    VS = 'VS',
    ZAHLUNGSWEISE = 'ZAHLUNGSWEISE'
}

export default GtmFormulareingabeField;